import React, { useContext } from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    CardMeta,
    CardDescription,
    Image,
} from 'semantic-ui-react';
import { UsersContext } from '../Contexts/UsersContext';


const UserCard = ({ userId }) => {
    const { users } = useContext(UsersContext);
    return (
        <>
            <Card key={userId}>
                <Image src={users[userId].picUrl || 'default-user-img.jpg'} />
                <CardContent>
                    <CardHeader content={users[userId].name} />
                    <CardMeta content={users[userId].location} />
                    <CardDescription content={users[userId].description} />
                </CardContent>
            </Card>
        </>
    );
};

export default UserCard;
